interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const MoonpayIcon = ({ ...props }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.3191 7.36824C22.3617 7.36824 24 5.70719 24 3.68412C24 1.63975 22.3404 0 20.3191 0C18.2766 0 16.6383 1.66105 16.6383 3.68412C16.6383 5.70719 18.2766 7.36824 20.3191 7.36824ZM9 24C4.02128 24 0 19.9752 0 14.992C0 10.0089 4.02128 5.98403 9 5.98403C13.9787 5.98403 18 10.0089 18 14.992C18 19.9752 13.9787 24 9 24Z"
      fill="#7D00FF"
    />
  </svg>
);
